import { api } from '@/api/api-client.config.ts';
import { useMutation } from '@tanstack/react-query';

type LoginParams = {
  email: string;
  password: string;
};

const login = (body: LoginParams): Promise<{ token: string }> =>
  api.post(`/login`, body);

export const useLoginMutation = () => {
  return useMutation({
    mutationKey: ['login'],
    mutationFn: login,
  });
};
